export enum DatabaseItemSortDirection {
  Ascending = '1',
  Descending = '-1',
}
